import { useCallback, useEffect } from "react";
import type { Category } from "../../models/Category";
import { DataState } from "../../models/DataState";
import { Status } from "../../models/Status";
import { CategoryDTO } from "./CategoryDTO";
import { CategoryService } from "../../services/CategoryService";
import { useBasePage } from "../../hooks/useBasePage";

const initialState: CategoryDTO = {
  searchText: "",
  status: Status.Active,
  skip: 0,
  limit: 20,
  total: 0,
  isDialogOpen: false,
  dialogMode: "Create",
  selectedData: {
    DataState: DataState.New,
    Code: "",
    Name: "",
    Description: "",
    ParentCategoryCode: "",
    ImageUrl: "",
    DisplayOrder: 0,
    ProductCount: 0,
    Status: Status.Active,
  },
  categories: [],
};
export function useCategory() {
  const { state, setState, setStateProperty, setStateProperties } =
    useBasePage<CategoryDTO>(initialState);
  const categoryService = CategoryService();
  const { skip, limit, categories } = state;
  useEffect(() => {
    initialize();
  }, []);
  const initialize = useCallback(async (): Promise<void> => {
    const data = await categoryService.GetAll(skip, limit);
    setStateProperties({
      skip: data.Skipped,
      limit: data.Limit,
      categories: data.Data,
    });
  }, [categories]);
  return { categories };
}
